import React from 'react';
import { DatePicker, Form, Input, Select } from 'antd';
import PropTypes, { array, object } from 'prop-types';

const { Option } = Select;
const { TextArea } = Input;

function AntDInputText({
  name,
  label,
  rules,
  itemAttributes,
  inputAttributes,
  type,
  options,
}) {
  return (
    <Form.Item
      key={name}
      label={label}
      name={name}
      rules={rules}
      className="mb-2"
      {...itemAttributes}
    >
      {(type === 'select' && (
        <Select
          placeholder="Select option"
          allowClear
          showSearch
          {...inputAttributes}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      )) ||
        (type === 'textarea' && <TextArea rows={4} {...inputAttributes} />) ||
        (type === 'date' && (
          <DatePicker
            style={{
              width: '100%',
            }}
            {...inputAttributes}
            format="DD/MM/YYYY"
          />
        )) ||
        (type === 'password' && <Input.Password {...inputAttributes} />) || (
          <Input {...inputAttributes} />
        )}
    </Form.Item>
  );
}

AntDInputText.defaultProps = {
  rules: [],
  options: [],
  itemAttributes: {},
  inputAttributes: {},
  type: 'text',
  label: null,
};

AntDInputText.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.oneOfType([array]),
  options: PropTypes.oneOfType([array]),
  itemAttributes: PropTypes.oneOfType([object]),
  inputAttributes: PropTypes.oneOfType([object]),
};

export default AntDInputText;
